import { Auth } from "aws-amplify";

const HANDLER_CONFIG = {
    "android": "androidhandler",
    "ios": "ioshandler"
}

const METHOD_CONFIG = {
    "getCurrentSession": { async: true },
    "getCurrentUser": { async: true },
    "updatePassword": {
        async: true,
        transformArgs: (args) => [args[1], args[2]]
    },
    "signOut": { async: false },
    "closePage": { async: false },
    "showMessage": { async: false }
}

export const DevicePromiseManager = (() => {
    let counter = 0;

    /* 
     * {
     *   [requestId]: { methodname, resolve, reject, timer },
     *   [requestId]: { methodname, resolve, reject, timer },
     *   ...
     * }
     */
    const pending = {}

    const TIMEOUT_MS = 10000;

    return {
        async call(methodname, args = []) {
            if (!METHOD_CONFIG.hasOwnProperty(methodname)) {
                return;
            }

            if (typeof window !== "undefined") {
                const appdevice = localStorage.getItem("appdevice");

                if (appdevice !== null) {
                    let deviceHandler = HANDLER_CONFIG.hasOwnProperty(appdevice) ? window[HANDLER_CONFIG[appdevice]] : undefined;
                    let hasDeviceMethod = deviceHandler ? typeof deviceHandler[methodname] === "function" : false;
                    let isMethodAsync = METHOD_CONFIG[methodname].async;

                    /* 
                     * If method is asynchronous, return a Promise,
                     * otherwise just call the method
                     */

                    if (isMethodAsync) {
                        return new Promise((resolve, reject) => {
                            if (deviceHandler) {
                                const requestId = "req_" + (++counter);

                                const timer = setTimeout(() => {
                                    delete pending[requestId];
                                    reject("Device call timed out");
                                }, TIMEOUT_MS)

                                pending[requestId] = { methodname, resolve, reject, timer }

                                if (!hasDeviceMethod) {
                                    return reject(`Device method '${methodname}' not found`);
                                }

                                const finalArgs = METHOD_CONFIG[methodname].hasOwnProperty("transformArgs")
                                    ? METHOD_CONFIG[methodname].transformArgs(args)
                                    : args

                                deviceHandler[methodname](
                                    requestId,
                                    "DevicePromiseCallback",
                                    ...finalArgs
                                );

                            } else {
                                return reject(`No ${appdevice} handler`)
                            }
                        })
                    } else if (!isMethodAsync) {
                        if (deviceHandler && hasDeviceMethod) {
                            deviceHandler[methodname](...args);
                        }
                    }
                } else {
                    if (methodname === "getCurrentSession") {
                        try {
                            const response = await Auth.currentSession();
                            if (response) {
                                return { ok: true, ...response };
                            }
                        } catch (error) { throw error; }
                    } else if (methodname === "getCurrentUser") {
                        try {
                            const response = await Auth.currentAuthenticatedUser();
                            if (response) {
                                return response;
                            }
                        } catch (error) { throw error; }
                    } else if (methodname === "updatePassword") {
                        try {
                            await Auth.changePassword(...args);
                        } catch (error) { throw error; }
                    } else if (methodname === "signOut") {
                        try {
                            await Auth.signOut();
                        } catch (error) { throw error; }
                    }
                }
            }
        },

        callback(requestId, deviceresultstr) {
            const entry = pending[requestId];
            if (!entry) return;

            clearTimeout(entry.timer);
            delete pending[requestId];

            let parsed;
            try {
                parsed = JSON.parse(deviceresultstr);
            } catch (error) {
                entry.reject("Invalid JSON from device");
                return;
            }

            if (parsed && (parsed.ok === false || parsed.error === true)) {
                if (parsed.ok === false) {
                    entry.reject(parsed.error || "Device error");
                } else if (parsed.error === true) {
                    entry.reject(parsed.message);
                }
            } else {
                entry.resolve(parsed.data !== undefined ? parsed.data : parsed)
            }
        }
    }
})();


if (typeof window !== "undefined") {
    window.DevicePromiseCallback = DevicePromiseManager.callback.bind(DevicePromiseManager);
}